<ng-template #errorTpl>
  <em-error-result
    status="error"
    title="An error occurred"
    [subTitle]="errorMsg ?? ''"
  ></em-error-result>
</ng-template>

<nz-card nzTitle="Development Milestones" class="em-area">
  <nz-skeleton [nzActive]="true" [nzLoading]="(table.loading$ | async) ?? false">
    <nz-table
      *emAlias="table.page$ | async as page"
      #taskTableRef
      [nzData]="page?.data ?? []"
      [nzFrontPagination]="false"
      [nzPageSizeOptions]="[5, 10, 20, 30]"
      nzSize="small"
      [nzPageSize]="table.perPage"
      [nzPageIndex]="table.pageIndex"
      (nzQueryParams)="table.onTableChange($event)"
      nzShowSizeChanger
      [nzTotal]="page?.total ?? 0"
      [nzNoResult]="errorMsg ? errorTpl : ''"
      class="em-no-table-row-hover"
    >
      <thead>
        <tr>
          <th>Code</th>
          <th>Process text</th>
          <th>Finish</th>
          <th>Forecasted finish</th>
          <th>Actual finish</th>
          <th>Status</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let task of taskTableRef.data; trackBy: trackByRef">
          <td>
            {{ task.explanation }}
          </td>
          <td>
            {{ task.processText }}
          </td>
          <td>
            {{ task.fixedFinishDate | date: 'shortDate' }}
          </td>
          <td>
            {{ task.forecastedFinish | date: 'shortDate' }}
          </td>
          <td>
            {{ task.actualFinishDate | date: 'shortDate' }}
          </td>
          <td>
            {{ task.status }}
          </td>
          <td class="action-column">
            <button
              *ngIf="task.status === taskStatus.Completed"
              nz-button
              nzType="primary"
              [nzGhost]="true"
              nz-tooltip
              nzTooltipTitle="Cancel Milestone"
              nz-popconfirm
              nzPopconfirmTitle="Are you sure?"
              (nzOnConfirm)="cancelMilestone(task)"
            >
              <i nz-icon nzType="close-circle" nzTheme="fill"></i>
            </button>
            <button
              nz-button
              nzType="primary"
              [nzGhost]="true"
              [disabled]="task.status === taskStatus.Completed"
              routerLink="."
              [queryParams]="task.id | emApplyPure: routeParam.edit"
              queryParamsHandling="merge"
              nz-tooltip
              nzTooltipTitle="Edit Milestone"
            >
              <i nz-icon nzType="edit" nzTheme="fill"></i>
            </button>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-skeleton>
</nz-card>
